import { Route } from "@angular/router";
import { HomeComponent } from "./components/home/home.component";
import { LoginComponent } from "./components/login/login.component";
import { CanActivateViaAuthService } from './shared/services/can-activate-via-auth.service';
import { CanActivateViaPermissionService } from './shared/services/can-activate-via-permission.service';

export const routerConfig : Route[] = [
  {
    path:'',
    component: HomeComponent,
    //canActivate:[CanActivateViaAuthService] <-- will use eventually
  },
  {
    path:'home',
    component: HomeComponent,
    //canActivate:[CanActivateViaAuthService], <-- will use eventually
  },
  {
    path:'login',
    component: LoginComponent,
  }
];



// WEBPACK FOOTER //
// ./src/app/router.config.ts